
export const ERROR_CREATE_ACTION_TYPE = ('error/CREATE');
export const ERROR_CLEAR_ACTION_TYPE = ('error/CLEAR');
export const ERROR_OPERATION_START_ACTION_TYPE = ('error/OPERATION_START');
export const ERROR_OPERATION_SUCCESS_ACTION_TYPE = ('error/OPERATION_SUCCESS');
export const ERROR_OPERATION_NOT_SUCCESS_ACTION_TYPE = ('error/OPERATION_NOT_SUCCESS');
